module.exports = __webpack_public_path__ + "img/ios-briefcase.67a166ff.svg";